import axios from "axios";

// axios.defaults.timeout =  5000; // ms
// axios.defaults.retry = 0; // count
// axios.defaults.retryDelay = 1000; // ms

// let defaultBaseURL = "https://stagestapi.carrotenglish.net";
let defaultBaseURL = "https://stapi.carrotenglish.net";

if (location.origin.includes("stage")) {
  //기본을 마스터로 하되, stage 인 경우에만 스테이지가 연결되도록 처리한다.
  //스테이지 사이트의 사용을 위함.
  defaultBaseURL = "https://stagestapi.carrotenglish.net";
}

const instance = axios.create({
  baseURL: defaultBaseURL,
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
});

instance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    var config = error.config;
    console.error("Network Error, Retry", config);
    console.log(error.response);
    if (error.response == "/login/msg") {
      alert("세션이 끊어졌습니다. 로그인 페이지로 이동합니다.");
      window.location.href = "/";
    } else {
      // If config does not exist or the retry option is not set, reject
      if (!config || !config.retry) {
        return Promise.reject(error);
      }

      // Set the variable for keeping track of the retry count
      config.__retryCount = config.__retryCount || 0;

      // Check if we've maxed out the total number of retries
      if (config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(error);
      }

      // Increase the retry count
      config.__retryCount += 1;

      // Create new promise to handle exponential backoff
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, config.retryDelay);
      });

      // Return the promise in which recalls axios to retry the request
      return backoff.then(function () {
        return instance(config);
      });
    }
  }
);

export default instance;
